// UpdateAppModal helper functions and data

export const backdropConfig = {
  opacity: 1,
  color: "#ffffff",
  className: "UpdateAppModal__backdrop"
};
